import React from 'react';

import { FarmOffer } from 'common/components/farm';
import { DisableProvider } from 'common/disabled-context';
import useStyles from './farm-details.styles';

const FarmDetails = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <DisableProvider>
        <FarmOffer />
      </DisableProvider>
    </div>
  );
};

export default FarmDetails;
